import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/eldos.jpeg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonZhandaulet = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Жандаулет Елдос Жандаулетұлы</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Bachelor of Mathematical and Computer Modeling, Master of Technical Sciences, PhD Candidate of Mathematical and Computer Modeling
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=57203723058'}>
                            <MyText><LinkOutlined /> Scopus (h=11)</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0003-2954-8769'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>ТОО «Astana IT University», сеньор-лектор, ДВНД. Стаж по профилю — 8 лет.</MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>Специалист по моделированию</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Проведение численного моделирования;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Написание научных статей;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Создание математических моделей для численного моделирования водного потока.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    PhD-кандидат по специальности «Математическое и компьютерное моделирование» по теме «Численное моделирование переноса осадка в подвижном слое земли сложного рельефа под действием потока». Навыки: ANSYS Fluent, MatLab, AutoCAD. Знание вычислительной гидродинамики.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - AP08857238 «Математическое моделирование ветрового потока и переноса загрязняющих примесей» (2020-2022), исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - AP08857306 «Параллельные алгоритмы для моделирования движения воздуха в носовой полости» (2020-2022), исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - AP09259783 «Моделирование распространения ОРВИ в воздушной среде» (2021-2023), исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - AP09058406 «Моделирование паводковых и прорывных волн при прорыве плотины» (2021-2023), исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR24993128 «ИАС трансграничных водных ресурсов» (2024-2026), исполнитель.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Публикации:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    1. Tayfur, Issakhov, Zhandaulet. Numerical simulation of flow and dam body sediment over a movable bed. Sigma Journal, 2022. [Scopus Q3]
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    2. Issakhov, Zhandaulet, Abylkassymova. Water Surface Movement During a Dam Break on a Slope with Cascade Dike. Water Resources Management, 2022. [Scopus Q1]
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    3. Issakhov, Zhandaulet, Omarova et al. A numerical assessment of social distancing. Scientific Reports, 2021. [Scopus Q1]
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    4. Issakhov, Zhandaulet. Numerical Study of Dam Break Waves on Movable Beds for Complex Terrain. Water Resources Management, 2020. [Scopus Q1]
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    5. Issakhov, Zhandaulet, Nogaeva. Numerical simulation of dam break flow for various obstacles. Int. J. of Multiphase Flow, 2018. [Scopus Q1]
                </MyText>
            </Flex>
        </Flex>
    );
};
